import { ComponentProps } from 'react'

import i18n from 'modules/core/lib/i18n'

import UpsellModal from 'modules/upsell/components/UpsellModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  onClose: () => void
}

const LegacyPlanHintModal = ({ onClose }: Props) => {
  const hintContent: ComponentProps<typeof UpsellModal.Text>['itemsContent'] = {
    title: i18n.t('product_updates.upgrade_legacy_plan.modal.title'),
    description: i18n.t('product_updates.upgrade_legacy_plan.modal.description'),
    items: [
      {
        icon: 'check',
        title: i18n.t('product_updates.upgrade_legacy_plan.modal.first_item.title'),
        description: i18n.t('product_updates.upgrade_legacy_plan.modal.first_item.description'),
      },
      {
        icon: 'check',
        title: i18n.t('product_updates.upgrade_legacy_plan.modal.second_item.title'),
        description: i18n.t('product_updates.upgrade_legacy_plan.modal.second_item.description'),
      },
      {
        icon: 'check',
        title: i18n.t('product_updates.upgrade_legacy_plan.modal.third_item.title'),
        description: i18n.t('product_updates.upgrade_legacy_plan.modal.third_item.description'),
      },
      {
        icon: 'check',
        title: i18n.t('product_updates.upgrade_legacy_plan.modal.fourth_item.title'),
        description: i18n.t('product_updates.upgrade_legacy_plan.modal.fourth_item.description'),
      },
    ],
  }

  return (
    <UpsellModal.Text
      buttonLabel={i18n.t('product_updates.upgrade_legacy_plan.modal.button')}
      requestDetail={{
        requestReason: ValidReasons.UpgradeFromLegacy,
        requestSource: 'marketplace-legacy-apps',
      }}
      onClose={onClose}
      itemsContent={hintContent}
    />
  )
}

export default LegacyPlanHintModal
